// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ScheduleHorizonControl-base__um6Mo{display:flex;align-items:center}.ScheduleHorizonControl-horizonSelect__UhjXn{flex:1;min-width:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "ScheduleHorizonControl-base__um6Mo",
	"horizonSelect": "ScheduleHorizonControl-horizonSelect__UhjXn"
};
export default ___CSS_LOADER_EXPORT___;
